/** 紙の耳（README「紙の端」）：4辺を5pxごとに0〜2.5px内側へずらす clip-path。seed で同じ紙は同じ形 */
export function deckle(w: number, h: number, seed = 1): string {
  let s = seed;
  const rnd = (): number => ((s = (s * 16807) % 2147483647) / 2147483647) * 2.5;
  const pts: string[] = [];
  for (let x = 0; x <= w; x += 5) pts.push(`${x}px ${rnd().toFixed(1)}px`);
  for (let y = 0; y <= h; y += 5) pts.push(`${(w - rnd()).toFixed(1)}px ${y}px`);
  for (let x = w; x >= 0; x -= 5) pts.push(`${x}px ${(h - rnd()).toFixed(1)}px`);
  for (let y = h; y >= 0; y -= 5) pts.push(`${rnd().toFixed(1)}px ${y}px`);
  return `polygon(${pts.join(',')})`;
}
